import { createAction } from 'redux-actions';

export const setStateDetallePolizaAction = createAction('SET_DETALLE_POLIZA');

export const setPlanSeleccionadoAction = createAction(
  'SET_PLAN_SELECCIONADO_DETALLE_POLIZA',
);

export const setShowFormAddCertificadoAction = createAction(
  'SET_SHOW_FORM_ADD_CERTIFICADO_DETALLE_POLIZA',
);

export const setLoadingDetallePolizaAction = createAction(
  'SET_LOADING_DETALLE_POLIZA_ACTION',
);

export const setCertificadosPropsAction = createAction(
  'SET_CERTIFICADOS_PROPS_ACTION',
);

export const setCertificadosAction = createAction(
  'SET_CERTIFICADOS_DETALLE_POLIZA_ACTION',
);

